import { createSelector } from 'reselect';
import { workItemSelectors } from '../../workItem';

export const getInitialValues = workItemId =>
  createSelector([workItemSelectors.getById], workItemById => workItemById[workItemId]);
